import React from 'react'
import { HelpModal } from '../help/help-modal.component'

export const FailedFutureGradUpgradeAlert = ({modalRef}) =>
  <HelpModal innerRef={modalRef} title='School not in database'>
    We are working to include your college in the near future.
  </HelpModal>